<style scoped>
.flex{
  display: flex;
}
.justify-between{
  justify-content: space-between;
}
.rounded-35{
  border-radius: 35px;
}
.text-14{
  font-size: 14px;
}
.leading-14{
  line-height: 14px;
}
.text-center{
  text-align: center;
}
.text-primaryBlack-2{
  color: #A1A4A9;
}
.w-46{
  width: 46px;
}
.bg-primaryGrey-2{
  background: #E9F1FF;
}
.text-primaryPurple{
  color: #2877FF;
}
.font-medium{
  font-weight: 500;
}
.w-12{
  width: 12px;
}
.h-12{
  height: 12px;
}
.mx-4{
  margin-top: 4px;
  margin-bottom: 4px;
}
.text-12{
  font-size: 12px;
}
.leading-12{
  line-height: 12px;
}
.px-4{
  padding-top: 4px;
  padding-bottom: 4px;
}
.px-8{
  padding-left: 8px;
  padding-right: 8px;
}
.py-4{
  padding-top: 4px;
  padding-bottom: 4px;
}
.border-solid{
  border-style: solid;
}
.leading-22{
  line-height: 22px;
}
.rounded-4{
  border-radius: 4px;
}
.align-center{
  align-items: center;
}
.border-05{
  border: 1px solid rgba(161, 164, 169, 0.37);
}
.rounded-4{
  border-radius: 4px;
}
.mx-4{
  margin-left: 4px;
  margin-right: 4px;
}
</style>
<template>
  <div >
    <div class="SwitchCalendar flex justify-between align-center">
      <van-radio-group v-model="radio" @change="onChange" class="flex">
        <van-radio v-for="item in shortcuts" icon-size="46px" :disabled="item.disabled" :key="item.value" :name="item.value">
          <template #icon="props">
            <div
                class="rounded-35 text-14 leading-14 text-center py-4 text-primaryBlack-2 w-46"
                @click="clickEmitHandler(item)"
                :class="{'radioBtn-active':props.checked,'text-primaryPurple':props.checked,'font-medium':props.checked}"
            >
              {{item.name}}
            </div>
          </template>
        </van-radio>
      </van-radio-group>
      <div @click="disabledCalendarEmit(disabledCalendar)" class="px-8 flex border-solid leading-22 border-05 rounded-4 align-center flex" :class="{'bg-primaryGrey-2':disabledCalendar.disabled}">
        <img src="https://s6.bihukankan.com/img/1646019416calendar.svg" class="w-12 h-12 mx-4" />
        <span class="text-12 text-primaryBlack-2">
          {{intervalTime.start}}
          <span class="px-4">至</span>
          {{intervalTime.end}}
        </span>
      </div>
    </div>
    <calendar :show="show" :value="calendarValue" :availableDate="$props.availableDate" @onConfirm="calendarConfirm" @close="show =false"></calendar>
  </div>
</template>

<script>
import calendar from "./component/calendar";
import dayjs from "moment";
export default {
  components: { calendar },
  props: {
    shortcuts: { type: Array, default: () => ([]) }, //配置
    value: { type: Array, default: () => ([]) },
    disabledCalendar: { type: Object,  default: () => ({}) },
    availableDate: {type: Number, default: 90, validator: value => value >= 0 }
  },
  data() {
    return {
      show: false,
      radio: "",
      calendarValue: [],
      // 日历数据
      intervalTime: {
        start: "",
        end: "",
        range: []
      }
    };
  },
  watch: {
    value: {
      handler(date) {
        const setDate = [
          dayjs(this.value[0]).toDate(),
          dayjs(this.value[1]).toDate()
        ];
        this.calendarValue = setDate; //设置日历
        this.setIntervalTime(setDate); //设置区间展示
        this.setRadios(setDate); //设置按钮
      },
      immediate: true
    }
  },
  methods: {
    clickEmitHandler(data) {
      data?.clickEmit && data?.clickEmit(data.disabled);
    },
    disabledCalendarEmit(calendar) {
      return (
        (!calendar.disabled && (this.show = true)) ||calendar?.clickEmit?.(calendar.disabled));
    },
    // 日历自定义
    calendarConfirm(data) {
      // 判断是否是近xxx天
      this.setRadios(data);
      this.setIntervalTime(data);
      // -------------------------------------------------
      this.$emit("input", this.intervalTime.range);
      this.$emit("onRadios", this.radio);
      
      this.show = false;
    },
    //修改单选按钮
    setRadios(data) {
      const date1 = dayjs(new Date());
      const intervalDay = date1.diff(data[0], "day"); //间隔天数
      const isShortcutsVal =
        this.shortcuts.findIndex(item => item.value == intervalDay) >= 0; //是否存在快捷选项中
      let radioValue = null; //重新赋值给快捷选项变量
      if (isShortcutsVal) {
        const { allDate } = setRadiosDateInterval(intervalDay); //对比
        const newTime =
          dayjs(data[0]).format("YYYYMMDD") + dayjs(data[1]).format("YYYYMMDD");
        const isRadio = allDate.join("") === newTime;
        radioValue = (isRadio && intervalDay) || null;
      }
      this.radio = radioValue;
    },
    //修改日历
    setIntervalTime(data) {
      this.intervalTime = {
        start: dayjs(data[0]).format("MM-DD"),
        end: dayjs(data[1]).format("MM-DD"),
        range: [
          dayjs(data[0]).format("YYYYMMDD"),
          dayjs(data[1]).format("YYYYMMDD")
        ]
      };
    },
    onChange(newV) {
      if (newV) {
        this.setDateInterval(newV);
      }
    },
    //设置时间
    setDateInterval(day = 1) {
      if (!day) {
        day = this.value;
      }
      // // 设置日历数据
      const [calendarStart, calendarEnd] = defaultDateInterval(day);
      this.calendarValue = [calendarStart.toDate(), calendarEnd.toDate()];
      this.calendarConfirm(this.calendarValue);
    }
  }
};
function setRadiosDateInterval(day = 1) {
	const dayNum = 1;
	const splitKey = "-";
	const defaultEndDate = dayjs()
		.subtract(dayNum, "days")
		.format(`YYYY${splitKey}MM${splitKey}DD`);
	const defaultStartDate = dayjs(defaultEndDate)
		.subtract(day - dayNum, "days")
		.format(`YYYY${splitKey}MM${splitKey}DD`); //默认30天
	const [yearEnd, monthEnd, dayEnd] = defaultEndDate.split(splitKey);
	const [yearStart, monthStart, dayStart] = defaultStartDate.split(
		splitKey
	);
	return {
		yearEnd, monthEnd, dayEnd,
		yearStart, monthStart, dayStart,
		allDate: [yearStart + monthStart + dayStart,
		yearEnd + monthEnd + dayEnd]
	}

}
function defaultDateInterval(day) {
  const defaultEndDate = dayjs().subtract(1, "days");
  const defaultStartDate = dayjs(defaultEndDate).subtract(day - 1, "days"); //默认30天
  return [defaultStartDate, defaultEndDate];
}
</script>

<style lang="less">
.SwitchCalendar {
  .radioBtn-active {
    background: rgba(103, 58, 226, 0.04);
  }
  .van-radio__icon {
    height: inherit;
  }
}
</style>